<script>
import Component from '~/sites/soh/pages/checkout/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/kosik',
      en: '/cart',
      sk: '/kosik',
    },
  },
}
</script>
